(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.controller('SourceEditController', [
    '$scope',
    '$window',
    'sourcesApi',
    function($scope, $window, sourcesApi) {
      // init values
      $scope.source = {
        name: '',
        type: '',
        active: 0,
        seller_name: '',
        seller_domain: '',
        seller_type: ''
      };

        $scope.log = {
            count: 0,
            data: [],
        };



      $scope.seller_types = [
          {name: 'HIDDEN', value: 'HIDDEN'},
          {name: 'PUBLISHER', value: 'PUBLISHER'},
          {name: 'INTERMEDIARY', value: 'INTERMEDIARY'},
          {name: 'BOTH', value: 'BOTH'}
      ];

      // load source from server
      if ($window.sourceId) {
        sourcesApi.read($window.sourceId).then(
          data => {
            $scope.source = data.source;
            $scope.log = data.log;
          },
          () => {
            console.error('could not load source');
          }
        );
      }

      sourcesApi.getTypes().then(types => {
        $scope.types = [];

        Object.keys(types).forEach(key => {
          $scope.types.push({
            name: types[key],
            value: key,
          });
        });
      });

      // try saving and process server side validation errors
      $scope.submitForm = () => {
        sourcesApi.save($scope.source).then(
          () => {
            $window.location.href = '/#!/supply/inventory/sources';
          },
            data => {
                defaultSaveErrorHandler($scope.sourceForm, data);
          }
        );
      };
    },
  ]);
})(window.angular);

/**
 * List Controller
 */
(function(angular) {
  'use strict';

  let app = angular.module('asSupplyMgr');

  app.controller('SourcesIndexController', [
    '$scope',
    'sourcesApi',
    function($scope, sourcesApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.loading = false;

      $scope.list = null;

      $scope.page = {
        number: 0,
        size: 500,
      };

      $scope.searchTerm = '';

      $scope.sort = {
        field: 'name',
        order: 'asc',
      };


        $scope.statusFilter = ['running','paused','paused'];

        $scope.$watch('statusFilter', function(newVal, oldVal) {
            if (newVal && oldVal && newVal !== oldVal) {
                $scope.fetch();
            }
        }, true);

      /**
       * If user presses enter in search box perform the search
       * @param e
       */
      $scope.checkSubmit = function(e) {
        if (e.originalEvent.charCode === 13) {
          $scope.search();
        }
      };

      $scope.search = function() {
        $scope.page.number = 0;

        $scope.fetch();
      };

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;

        sourcesApi.getList($scope.sort, $scope.searchTerm, $scope.page, $scope.statusFilter).then(
          function(data) {
            $scope.list = {
              count: data.count,
              data: data.data,
              maxPage: Math.floor(data.count / $scope.page.size),
            };
            $scope.loading = false;
          },
          function() {
            $scope.list = {
              count: 0,
              data: [],
              maxPage: null,
            };
            $scope.loading = false;
          }
        );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      $scope.changeState = function(source) {
        let id = source.id;
        let newState = source.active === 'Active' ? 0 : 1;
        sourcesApi.changeState(id, newState).then(function() {
          $scope.fetch();
        });
      };

      /**
       * show the delete confirmation dialog
       * @param source
       */
      $scope.promptDelete = function(source) {
        $scope.sourceToDelete = source;
        $('#delete-modal').modal('show');
      };

      /**
       * delete an source item
       * @param source
       */
      $scope.delete = function(source) {
        sourcesApi.delete(source.id).then(function() {
          $scope.fetch();
        });
      };

      /**
       * export list to csv
       */
      $scope.export = function() {
        let url = '/supply/inventory/sources/export' + getReportUrl($scope.sort, $scope.searchTerm, {'status': $scope.statusFilter});

        window.location.href = url;
      };

      $scope.fetch();
    },
  ]);
})(window.angular);
